//src/constants/networks.js

export const NETWORKS = ["Jazz", "Zong", "Telenor", "Tabeeb", "Ufone", "Easypaisa"];
